/**
 * @desc 基础设备列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** page */
  page?: number;
  /** size */
  size?: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.Page<defs.EquipmentDTO>>> {
  return defHttp.get({
    url: '/web/equipment/list/basic',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.Page<defs.EquipmentDTO>>> {
  return defHttp.get({
    url: '/mock/web/equipment/list/basic',

    params,
  });
}
